export default "__VITE_ASSET__6ee2708b__"